export enum DashboardViewMode {
	Loading = 'loading',
	Staff = 'staff',
	OrgMember = 'org-member',
	NoActiveOrganizations = 'no-active-organizations'
}
